export default {
  dialog: [
    {
      text:'To climb this mountain you must decifer all the questions.',
      type: 'statement'
    },
    {
      text:'Bring it!',
      type: 'statement'
    },
    {
      text:'First: how is a female rabbit called?',
      type: 'question',
      options: [
        'Bunny',
        'Doe',
        'Rabbitess'
      ],
      right: 1
    },
    {
      text:'Second: what is the record for heaviest rabbit?',
      type: 'question',
      options: [
        'half ton',
        '200 kilograms',
        '55 pounds'
      ],
      right: 2
    },
    {
      text:'Here comes the last one.',
      type: 'statement'
    },
    {
      text:'How long does a rabbit live?',
      type: 'question',
      options: [
        '6 months',
        'around 10 years',
        'around 80 years'
      ],
      right: 1
    }
  ]
}